export default __webpack_public_path__ + "static/media/bag1.b79aca3a.jpg";